export { ButtonColor, FuncType, ButtonType, } from './enum';
